module.exports = __webpack_public_path__ + "static/scale-model-of-riley-arts-gallery-in-torrance-california-dbb0be9731a0a65a8f02add222ffb4c2.png";